import React, { Component } from 'react';
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from './../../../img/logo.svg';
import './forgotPasswordStyle.scss';
import loginService from '../loginService';
import swal from 'sweetalert';

const LoginService = new loginService();

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isError: false,
            validated: false,
        };
        this.formSubmit = this.formSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Ui rendering for class component
     */
    render() {
        //Set state variables for ui rendering
        const { email, validated } = this.state;
        return (
            <div className="dummy">
                <div className="content-box">
                    <Container className="p-4 mt-5">
                        <img className="branding-login-fpw" src={logo} alt="Therigy Logo" />
                    </Container>
                    {/* Container for forgot password form */}
                    <Container className="p-4 mt-3 log-box shadow">
                        {/* Form container for forgot password inputs */}
                        <Form validated={validated} onSubmit={this.formSubmit} noValidate>
                            <Row>
                                <h2 className="pwr-h2"> Password Reset</h2>
                                <p className="pwr-info">
                                    Enter your account email address. We&apos;ll send you an email with instructions to reset your password.
                                </p>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group controlId="formBasicEmail">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Email"
                                            autoComplete="off"
                                            value={email}
                                            onChange={this.handleChange}
                                            required
                                            pattern="^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a valid email address.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={6} className="pt-2">
                                    <Form.Group controlId="formBasicPassword" className="m-0">
                                        <Form.Text className="forgot-password">
                                            <Link to="/login">Back to Sign in</Link>
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Button type="submit" className="submit-btn" variant="primary" size="lg" block>
                                        Send Email
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </div>
                {/* Footer informations */}
                <div className="login-footer">
                    <p className="footer-text text-center m-0">
                        For immediate assistance, contact Tech Support by phone at
                    </p>
                    <p className="footer-text text-center">
                        <span>407.992.8750 x3</span> or via email at
                        <span>
                            <a href="mailto:support@therigy.com">support@therigy.com</a>
                        </span>
                    </p>
                </div>
            </div>
        );
    }

    /**
     * Input change method for setting email, password to state
     * @param evt event
     */
    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        //Set state for validation
        if (name === 'email') {
            this.setState({ email: value, validated: false });
        }
    };

    /**
     * Form submit
     * @param event form submit event
     */
    formSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            //Set state for validation
            this.setState({ validated: true });
            event.stopPropagation();
        } else {
            try {
                var res = await LoginService.sendForgotPasswordEmail(this.state.email);
                if (res && res.status === 'Failure') {
                    swal({
                        title: 'Something went wrong',
                        text: res.message + ', Please try again.',
                        icon: 'error',
                        button: 'OK',
                    });
                } else {
                    swal({
                        title: res.status,
                        text: 'An email has been sent to ' + this.state.email + ' with further instructions.',
                        icon: 'success',
                        button: 'OK',
                    }).then(() => {
                        this.props.history.push('/login');
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }
    };
}

ForgotPassword.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(ForgotPassword);
